import axios from 'axios';
// import { mapResponse } from './transform';

export default {
  async getProductList(context, { sort, payload }) {
    try {
      const { data } = await axios.post(
        `${process.env.API_BASE_URL}/products/health${sort ? `?sort=${sort}` : ''}`,
        payload
      );
      const response = data.data;
      context.commit('setListProduct', response);
    } catch (error) {
      return error;
    }
  }
};
